export const CustomerCompanyRoutes = {
    AddCustomerCompanies: "CustomerCompany/AddCustomerCompanies",
    ChangeCustomerCompanies: "CustomerCompany/ChangeCustomerCompanies"
}